import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "../Blogs/BlogDetails.css";
import Postd from "./Postd";

const BlogDetails = () => {
  const { id } = useParams(); // Get the id from the URL
  const [blog, setBlog] = useState(null);

  const blogData = [
    {
      id: 1,
      title: "Managing Deadlines in Financial Practices",
      date: "January 23, 2025",
      views: 340,
      comments: 0,
      author: "Jane Doe",
      mainImage: "/mw.webp", // Replace with actual image URL
      content: `Time Management for Financial and Tax Practices is crucial in maintaining high productivity and quality services. Effective time management helps professionals prioritize tasks, meet deadlines, and ensure client satisfaction in a fast-paced environment. By focusing on high-priority tasks and delegating less urgent work, financial professionals can maximize their impact while reducing stress. With the right strategies in place, time management ensures that professionals stay organized and efficient, leading to better decision-making and improved outcomes. Embracing time-saving technologies, such as automated scheduling and task management tools, further enhances productivity, allowing firms to focus more on strategic growth rather than day-to-day operations.`,
      blockquote: `Effective time management is crucial for financial professionals to balance workloads and improve client outcomes.`,
      categoriesContent: {
        "Financial Advice":
          "Expert advice on handling finances in a time-efficient manner.",
        "Tax Management":
          "Techniques and best practices for managing tax-related work effectively.",
        Productivity:
          "Strategies to increase productivity in financial practices through effective time management.",
        "Financial Planning":
          "Insights on managing time to better plan and execute financial strategies.",
      },
      tagsContent: {
        "Time Optimization":
          "Key methods and tools to optimize time in financial and tax practices.",
        "Work-Life Balance":
          "Strategies to maintain a healthy work-life balance in financial and tax professions.",
        "Client Management":
          "How time management improves client communication and service delivery.",
      },
      servicesContent: {
        "Financial Consulting":
          "Offering time-efficient solutions for financial practices, improving decision-making and client outcomes.",
        "Tax Services":
          "Time management in tax services ensures timely and accurate filing and compliance.",
        "Business Advisory":
          "Helping businesses streamline operations and manage their financial time better.",
        "Estate Planning":
          "Efficient management of time in estate planning ensures that clients’ needs are met promptly.",
        "Audit Services":
          "Timely audits are crucial for clients' financial health; we ensure that audits are done within strict timelines.",
        "Financial Technology":
          "Leveraging technology for time-saving solutions in financial planning and tax management.",
      },
    },
    {
      id: 2,
      title: "Ensuring Compliance Through Tax Services",
      date: "January 23, 2025",
      views: 410,
      comments: 0,
      author: "John Smith",
      mainImage: "/lc.webp", // Replace with actual image URL
      content: `Tax Advisory Services are essential for businesses to navigate the complex landscape of tax laws and regulations. Effective tax advisory helps businesses optimize their tax liabilities, ensuring compliance with ever-changing laws and avoiding costly penalties. A comprehensive tax strategy not only helps minimize tax exposure but also maximizes potential savings, which can directly contribute to business growth. With the right advisory, businesses can plan for future tax obligations, manage cash flow more effectively, and make better financial decisions. Moreover, leveraging expert tax advice ensures businesses stay ahead of new tax reforms, industry changes, and global trends. This proactive approach can protect a company from unexpected tax burdens, allowing it to reinvest savings into growth opportunities and expansion.`,
      blockquote: `Tax advisory is key to safeguarding your business against unexpected tax liabilities and maximizing growth opportunities.`,
      categoriesContent: {
        "Business Growth":
          "How tax advisory services can fuel long-term business growth through strategic planning.",
        "Corporate Taxation":
          "Understanding corporate tax strategies and their impact on overall business performance.",
        Compliance:
          "Ensuring businesses comply with tax regulations, avoiding penalties and fostering trust.",
        "Financial Planning":
          "Incorporating tax strategy into your business's financial planning for optimal results.",
      },
      tagsContent: {
        "Tax Strategy":
          "Comprehensive strategies for minimizing tax liabilities while maintaining full compliance.",
        "Tax Efficiency":
          "How to improve your business’s financial efficiency through effective tax planning.",
        "Tax Laws":
          "Stay updated on the latest tax laws and regulations to ensure your business is always in compliance.",
      },
      servicesContent: {
        "Corporate Tax Advisory":
          "Providing businesses with tailored advice on corporate tax planning and optimization.",
        "International Tax Consulting":
          "Helping businesses navigate the complexities of international tax laws and global compliance.",
        "Tax Compliance Services":
          "Ensuring your business stays compliant with local, state, and federal tax regulations.",
        "Indirect Taxes":
          "Advisory on indirect taxes, including VAT, sales tax, and other transactional taxes.",
        "Tax Dispute Resolution":
          "Providing expert representation in tax disputes and negotiations with tax authorities.",
        "Wealth Management":
          "Incorporating tax-efficient strategies into your personal and corporate wealth management plan.",
      },
    },
    {
      id: 3,
      title: "Navigating Legal Challenges in Estate Planning",
      date: "January 23, 2025",
      views: 350,
      comments: 0,
      author: "Mary Johnson",
      mainImage: "/fl.webp", // Replace with actual image URL
      content: `Estate Planning is a critical process for individuals to ensure that their assets are distributed according to their wishes after they pass away. Professional advice in estate planning helps individuals create a clear and legally sound plan for the distribution of their wealth, minimizing potential disputes among heirs. By consulting with experts, individuals can structure their estate to reduce estate taxes, avoid probate, and protect assets from creditors. A well-executed estate plan also includes provisions for healthcare decisions and guardianship of minor children. Estate planning professionals can help navigate complex issues like trust creation, charitable giving, and business succession planning, ensuring that the plan reflects personal goals and family dynamics. This proactive approach not only protects your assets but also provides peace of mind for both you and your loved ones, knowing that the estate will be handled as intended.`,
      blockquote: `Professional estate planning ensures your legacy is protected, your family is cared for, and your wishes are respected.`,
      categoriesContent: {
        "Wealth Management":
          "Strategic advice for managing and distributing wealth effectively through estate planning.",
        "Tax Efficiency":
          "How professional estate planning helps minimize estate taxes and avoid unnecessary costs.",
        "Family Protection":
          "Ensuring your loved ones are provided for and your wishes are followed with the right estate plan.",
        "Retirement Planning":
          "Integrating estate planning into your retirement strategy for long-term financial security.",
      },
      tagsContent: {
        Trusts:
          "Understanding the role of trusts in managing and distributing your estate efficiently.",
        Wills:
          "The importance of a clear and legally binding will in estate planning.",
        "Healthcare Decisions":
          "How to incorporate healthcare directives into your estate plan for medical decision-making.",
      },
      servicesContent: {
        "Trust Creation":
          "Professional assistance in creating trusts to protect and distribute assets effectively.",
        "Will Drafting":
          "Legal guidance in drafting wills that reflect your final wishes with clarity and precision.",
        "Tax Strategies":
          "Optimizing your estate to minimize tax liabilities and preserve more wealth for heirs.",
        "Business Succession Planning":
          "Planning the future of your business to ensure continuity and stability after your passing.",
        "Charitable Giving":
          "Incorporating philanthropy into your estate plan through charitable donations and foundations.",
        "Guardianship Planning":
          "Ensuring the proper guardianship of minor children with clear provisions in your estate plan.",
      },
    },
    {
      id: 4,
      title: "Managing Business Finances for Growth",
      date: "January 23, 2025",
      views: 470,
      comments: 0,
      author: "Sarah Lee",
      mainImage: "/rl.webp", // Replace with actual image URL
      content: `Corporate finance is a vital aspect of business operations, focusing on how companies raise capital, allocate resources, and manage financial risks. Understanding corporate finance helps entrepreneurs make informed decisions on how to fund their business, whether through equity, debt, or a mix of both. Key concepts in corporate finance include capital structure, financial modeling, and cash flow management, all of which play a crucial role in driving business growth and sustainability. Entrepreneurs must also understand the importance of financial analysis in assessing company performance and determining the right strategies for expansion. By effectively managing corporate finances, businesses can minimize risks, maximize returns, and create long-term value for shareholders. Moreover, strategic corporate finance planning ensures that businesses are well-equipped to handle economic fluctuations, seize new opportunities, and navigate challenges like mergers, acquisitions, and restructuring.`,
      blockquote: `Corporate finance provides entrepreneurs with the tools to optimize capital allocation, mitigate risks, and drive business success.`,
      categoriesContent: {
        "Business Strategy":
          "How corporate finance aligns with and supports long-term business strategies.",
        "Capital Structure":
          "Insights into balancing debt and equity for optimal financial performance.",
        "Financial Planning":
          "Developing comprehensive financial plans to guide business growth and stability.",
        "Investment Analysis":
          "Understanding investment opportunities and making strategic decisions based on financial analysis.",
      },
      tagsContent: {
        "Financial Modeling":
          "Building financial models to predict company performance and guide decision-making.",
        "Cash Flow Management":
          "Managing cash flow effectively to ensure business liquidity and growth.",
        "Risk Management":
          "Identifying and managing financial risks that could impact business stability.",
      },
      servicesContent: {
        "Business Valuation":
          "Professional services to assess the value of your business for growth, mergers, or acquisitions.",
        "Capital Raising":
          "Expert advice on raising capital through equity, debt, or alternative financing options.",
        "Financial Forecasting":
          "Providing accurate financial forecasts to support business planning and decision-making.",
        "Mergers & Acquisitions":
          "Guiding businesses through mergers, acquisitions, and restructuring processes for growth.",
        "Corporate Restructuring":
          "Helping businesses streamline operations and improve financial health through restructuring strategies.",
        "Investment Advisory":
          "Offering advice on investment opportunities to grow wealth and enhance business portfolios.",
      },
    },
  ];

  useEffect(() => {
    // Find the blog that matches the selected ID
    const selectedBlog = blogData.find((blog) => blog.id === parseInt(id));
    setBlog(selectedBlog);
  }, [id]);

  if (!blog) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Postd />

      <div className="blog-details-container">
        {/* Main Content */}
        <div className="main-content">
          <img src={blog.mainImage} alt={blog.title} className="main-image" />
          <h1 className="blog-title">{blog.title}</h1>
          <div className="meta-info">
            <span>{blog.date}</span> | <span>{blog.views} Views</span> |{" "}
            <span>{blog.comments} Comments</span>
          </div>
          <p className="blog-content">{blog.content}</p>
          <blockquote className="blockquote">{blog.blockquote}</blockquote>

          <h2 className="sub-title">Additional Insights</h2>
          <p className="blog-content">
            We provide expert legal assistance to help you achieve the justice
            and support you deserve. Let us stand by your side.
          </p>
        </div>

        {/* Sidebar */}
        <div className="sidebar">
          <div className="widget">
            <h3>Categories</h3>
            <ul>
              {Object.keys(blog.categoriesContent).map((category, index) => (
                <li key={index}>
                  <strong>{category}</strong>:{" "}
                  {blog.categoriesContent[category]}
                </li>
              ))}
            </ul>
          </div>
          <div className="widget">
            <h3>Tags</h3>
            <div className="tags">
              {Object.keys(blog.tagsContent).map((tag, index) => (
                <span key={index} className="tag">
                  {tag}: {blog.tagsContent[tag]}
                </span>
              ))}
            </div>
          </div>
          <div className="widget">
            <h3>Our Services</h3>
            <ul>
              {Object.keys(blog.servicesContent).map((service, index) => (
                <li key={index}>
                  <strong>{service}</strong>: {blog.servicesContent[service]}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetails;
